import { useCallback, useRef } from 'react';

import { useGlobalAppState } from '../../../../context/GlobalAppState';
// @REVIEW: This needs to be moved elsewhere, so we don't import it from a screen
import { type ReorderStep } from '../../../../screens/ReorderingScreen/machines/Reorder.machine';
import { type RouteInfo, useRouteObserver } from '../useRouteObserver';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Cancels the reorder flow when navigating away from a reorder modal screen.
 */
export const useCancelReorderOnModalExit = () => {
  const { reorderMachineRef } = useGlobalAppState();
  // ─── Refs ────────────────────────────────────────────────────────────

  const previousPathnameRef = useRef('');

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handleRouteChange = useCallback(
    (route: RouteInfo) => {
      const previousPathname = previousPathnameRef.current;
      const reorderStep = REORDER_PATHNAME_TO_STEP[previousPathname];
      const isReorderPath = REORDER_PATHNAME_TO_STEP[route.pathname];

      previousPathnameRef.current = route.pathname;

      if (!reorderStep || isReorderPath) return;

      reorderMachineRef.send({ type: 'CANCEL_REORDER', step: reorderStep });
    },
    [reorderMachineRef],
  );

  // ─── Effects ─────────────────────────────────────────────────────────

  useRouteObserver({ onChange: handleRouteChange });
};

// ─── Constants ──────────────────────────────────────────────────────────────

const REORDER_PATHNAME_TO_STEP: Record<string, ReorderStep> = {
  '/reorder-confirm-location': 'locationConfirmation',
  '/reorder-change-location': 'locationSearch',
  '/reorder-conflict-review': 'conflictReview',
  '/reorder-active-bag-warning': 'activeBagWarning',
};
